import React from 'react';
import Modal from './Modal';
import './css/Modal.css';

const LogoutConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="로그아웃"
      description="부스바월드에서 로그아웃 합니다."
      footer={
        <>
          <button className="btn-cancel" onClick={onClose}>취소</button>
          <button className="btn-confirm" type="button" onClick={() => onConfirm?.()}>로그아웃</button>
        </>
      }
    />
  );
};

export default LogoutConfirmModal;
